import { t } from 'i18next';
import { Trans } from 'react-i18next';
import useUserQuery from '../../../components/api/queries/useUserQuery';

interface BettieAgreementSectionProps {
  isBilling?: boolean;
  textClassName?: string;
}

const BettieAgreementSection = ({
  isBilling = false,
  textClassName
}: BettieAgreementSectionProps) => {
  const user = useUserQuery();
  const TERM_LIST = [
    ...(isBilling ? [{ id: 1, title: t('Agreement.event'), category: 'terms_of_service' }] : []),
    { id: 2, title: t('Agreement.checkOrder'), category: 'terms_of_service' },
    { id: 3, title: t('Agreement.protectPrivacy'), category: 'privacy_policy' }
  ];

  return (
    <div className="flex flex-col gap-[16px]">
      {TERM_LIST.map((term) => (
        <div key={term.id} className="flex items-center justify-between">
          <p
            className={`text-[13px] leading-[16px] ${term.id === 1 ? 'text-text-primary' : 'text-text-main-lv3'} ${textClassName ?? ''}`}
          >
            {term.id === 1 ? (
              <Trans
                i18nKey="Agreement.event"
                components={{ span: <span className="font-bold" /> }}
              />
            ) : (
              term.title
            )}
          </p>
          <a
            href={
              term.id === 1
                ? '/event/auto-topup'
                : `/fanhearts?path=terms&category=${term.category}&locale=${user?.locale}`
            }
            className={`text-[13px] leading-[16px] ${textClassName ? textClassName : 'text-text-main-lv3'} underline`}
          >
            {t('Agreement.detail')}
          </a>
        </div>
      ))}
    </div>
  );
};

export default BettieAgreementSection;
